import { appFeaturesCollection } from './firebase'

export function getAppFeatures() {
  return appFeaturesCollection.doc('webPage').get()
}
